import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Transition as _Transition, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../assets/img/logo-vim.svg'


const _withScopeId = n => (_pushScopeId("data-v-4f19870a"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "logo-container"
}
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: "Indisch Monument logo"
}, null, -1))
const _hoisted_3 = {
  key: 0,
  class: "content-count"
}
const _hoisted_4 = {
  key: 0,
  class: "utils"
}
const _hoisted_5 = { class: "utils-links" }
const _hoisted_6 = { class: "utils-link" }
const _hoisted_7 = { class: "utils-link" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "hover-text" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "visually-hidden" }, ". "),
  /*#__PURE__*/_createTextVNode(" Deel je gedachten door een persoonlijke herinnering of boodschap achter te laten bij dit digitale monument. ")
], -1))

import { onMounted, ref } from 'vue';

import DropdownMenu from '@/components/DropdownMenu.vue';
import MenuAboutLinks from '@/components/MenuAboutLinks.vue';
import MenuContent from '@/components/MenuContent.vue';
import { useInterfaceSettings } from '@/store/useInterfaceSettings';
import { useOverviewIndexes } from '@/store/useOverviewIndexes';
import { logInteractionEvent } from '@/utils/analytics';
import TagsDropdownContent from './Tags/TagsDropdownContent.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'Menu',
  setup(__props) {

const { showLogo, showTotals, showTopMenu } = useInterfaceSettings();
const { statisticsTotals } = useOverviewIndexes();
const init = ref<boolean>(false);

onMounted(async () => {
  init.value = true;
});

const onMelatiButtonHover = () => {
  logInteractionEvent({
    page_type: 'home',
    event_name: 'add_melati_cta',
    interaction_type: 'hover'
  });
};

const onMelatiButtonClick = () => {
  logInteractionEvent({
    page_type: 'home',
    event_name: 'add_melati_cta',
    interaction_type: 'click'
  });
};

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_Icon = _resolveComponent("Icon")!

  return (_openBlock(), _createElementBlock("header", {
    class: _normalizeClass(["main-menu", { show: init.value }])
  }, [
    _createVNode(_Transition, { name: "quick-fade" }, {
      default: _withCtx(() => [
        (_unref(showLogo))
          ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
              _createVNode(_component_router_link, { to: "/" }, {
                default: _withCtx(() => [
                  _hoisted_2
                ]),
                _: 1
              }),
              _createVNode(_Transition, { name: "quick-fade" }, {
                default: _withCtx(() => [
                  (_unref(statisticsTotals) && _unref(showTotals))
                    ? (_openBlock(), _createElementBlock("p", _hoisted_3, _toDisplayString(_unref(statisticsTotals).all) + " verhalen", 1))
                    : _createCommentVNode("", true)
                ]),
                _: 1
              })
            ]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }),
    _createVNode(_Transition, { name: "quick-fade" }, {
      default: _withCtx(() => [
        (_unref(showTopMenu))
          ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
              _createElementVNode("div", _hoisted_5, [
                _createVNode(_component_router_link, {
                  class: "utils-link",
                  to: "/tijdlijn"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode("Tijdlijn")
                  ]),
                  _: 1
                }),
                _createVNode(DropdownMenu, { "full-width": "" }, {
                  trigger: _withCtx(({ isExpanded }) => [
                    _createElementVNode("span", _hoisted_6, [
                      _createTextVNode("Alle thema's "),
                      _createVNode(_component_Icon, {
                        "aria-hidden": "true",
                        name: isExpanded ? 'up' : 'down',
                        class: "chevron"
                      }, null, 8, ["name"])
                    ])
                  ]),
                  content: _withCtx(() => [
                    _createVNode(TagsDropdownContent)
                  ]),
                  _: 1
                }),
                _createVNode(DropdownMenu, null, {
                  trigger: _withCtx(({ isExpanded }) => [
                    _createElementVNode("span", _hoisted_7, [
                      _createTextVNode("Over ons "),
                      _createVNode(_component_Icon, {
                        "aria-hidden": "true",
                        name: isExpanded ? 'up' : 'down',
                        class: "chevron"
                      }, null, 8, ["name"])
                    ])
                  ]),
                  content: _withCtx(({ collapse }) => [
                    _createVNode(MenuAboutLinks, { onClick: collapse }, null, 8, ["onClick"])
                  ]),
                  _: 1
                })
              ]),
              _createVNode(MenuContent),
              _createVNode(_component_router_link, {
                onMouseover: onMelatiButtonHover,
                onClick: onMelatiButtonClick,
                to: "/melati/new",
                class: "outline-btn melati-btn utils-link"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_Icon, { name: "melati" }),
                  _createTextVNode(" Plaats je melati "),
                  _hoisted_8
                ]),
                _: 1
              })
            ]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    })
  ], 2))
}
}

})